module.exports = __webpack_public_path__ + "static/screenshot4-18e9cc2becb1de1cdae09b7571872fae.png";